import { useState } from "react";
import styled from "styled-components";
import { FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { BiMenu, BiX } from "react-icons/bi"
import { useNavigation } from "../../hooks/useNavigation";
import { Container } from "../../theme/styles";
import logoSrc from "../../assets/images/logo.png"
import { Search } from "./components/Search";
import { NavItem } from "./components/NavItem";
import { Link } from "react-router-dom";
import medias_url from "../../mocks/social_media";

interface NavigatorProps {
  isMenuOpen?: boolean;
}

export function Header() {
  const navigation = useNavigation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <Content>
      <ContainerTop>
        <LinkUI to="/">
          <LogoUI src={logoSrc}  />
        </LinkUI>
        <SocialList>
          <SocialItem>
            <SocialLinkUI href={medias_url.facebook} target="_blank">
              <FaFacebookF />
            </SocialLinkUI>
          </SocialItem>
          <SocialItem>
            <SocialLinkUI href={medias_url.instagram} target="_blank">
              <FaInstagram />
            </SocialLinkUI>
          </SocialItem>
          <SocialItem>
            <SocialLinkUI href={medias_url.twitter} target="_blank">
              <FaTwitter />
            </SocialLinkUI>
          </SocialItem>
          <SocialItem>
            <SocialLinkUI href={medias_url.youtube} target="_blank">
              <FaYoutube />
            </SocialLinkUI>
          </SocialItem>
          <SocialItem>
            <SocialLinkUI href={medias_url.linkedin} target="_blank">
              <FaLinkedinIn />
            </SocialLinkUI>
          </SocialItem>
        </SocialList>
        {isMenuOpen ? (
            <CloseButton onClick={() => toggleMenu()} size={44} />
        ) : (
          <MenuButton onClick={() => toggleMenu()} size={44} />
        )}
      </ContainerTop>
      <ContainerBottom>
        <Navigator isMenuOpen={isMenuOpen}>
          <NavList>
            {navigation.map((item, index) => {
              return (
                <NavItem key={index} item={item} subMenuClick={(e) => {setIsMenuOpen(false)}} />
              );
            })}
          </NavList>
          <Search />
        </Navigator>
      </ContainerBottom>
    </Content>
  );
}

const Content = styled.header`
  background-color: ${({ theme }: any) => theme.colors.blue.dark};
  height: 140px;
  position: relative;
  z-index: 2;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    height: auto;
    position: static;
  }
`;

const ContainerTop = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ContainerBottom = styled(Container)`
  padding: 0;
`;

const Navigator = styled.nav<NavigatorProps>`
  transform: translateY(-6px);
  background-color: ${({ theme }: any) => theme.colors.blue.dark};
  padding-left: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1212px;
  z-index: 2;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    transform: none;
    position: fixed;
    top: 0;
    left: ${({ isMenuOpen }) => isMenuOpen ? 0 : '40%'};
    right: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.blue.dark};
    flex-direction: column;
    padding: 100px 0;
    transition: all 0.2s;
    overflow: auto;
    opacity: ${({ isMenuOpen }) => isMenuOpen ? 1 : 0};
    visibility: ${({ isMenuOpen }) => isMenuOpen ? 'visible' : 'hidden'};
  }
`;

const LogoUI = styled.img`
  width: 172px;
  margin-top: 12px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100px;
    margin: 10px 0 4px;
  }
`;

const SocialList = styled.ul`
  display: flex;
  list-style-type: none;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: none;
  }
`;

const SocialItem = styled.li`
  padding: 0 6px;
`;

const NavList = styled.ul`
  display: flex;
  list-style-type: none;
  
  * {
    font-family: 'Coolvetica Condensed', Arial, Helvetica, sans-serif;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
    width: 100%;
    padding: 0 0 0 32px;
  }
`;

const LinkUI = styled(Link)`
  color: #fff;

  &:hover, &:active {
    color: ${({ theme }: any) => theme.colors.pink.light};
  }
`;

const SocialLinkUI = styled.a`
  color: #fff;

  &:hover, &:active {
    color: ${({ theme }: any) => theme.colors.pink.light};
  }
`;

const CloseButton = styled(BiX)`
  display: none;
  
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: block;
    color: #fff;
    position: relative;
    z-index: 3;
    position: fixed;
    right: 14px;
    cursor: pointer;
  }
`;

const MenuButton = styled(BiMenu)`
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: block;
    color: #fff;
    position: relative;
    z-index: 3;
    cursor: pointer;
  }
`;